import { createActions } from '@manager-base/app-base/config/data-access';
import { BASE_PATH_API } from '@manager-base/app-base/environment/paths/constants';

const actions = {
    getRentalHistoryVerificationSettings: {
        method: 'GET',
        url: `${BASE_PATH_API}/rentalHistoryVerificationSettings`
    },
    updateRentalHistoryVerificationReminders: {
        method: 'POST',
        url: `${BASE_PATH_API}/rentalHistoryVerificationSettings/reminders`
    },
    updateRentalHistoryVerificationFormInstructions: {
        method: 'POST',
        url: `${BASE_PATH_API}/rentalHistoryVerificationSettings/formInstructions`
    },
    updateRentalHistoryVerificationQuestions: {
        method: 'POST',
        url: `${BASE_PATH_API}/rentalHistoryVerificationSettings/formQuestions`
    },
    updateRentalHistoryVerificationFormHeader: {
        method: 'POST',
        url: `${BASE_PATH_API}/rentalHistoryVerificationSettings/formHeader`
    },
    updateApplicantAuthorization: {
        method: 'POST',
        url: `${BASE_PATH_API}/rentalHistoryVerificationSettings/applicantAuthorization`
    },
    getPdfPreview: {
        method: 'GET',
        url: `${BASE_PATH_API}/rentalHistoryVerificationSettings/pdfPreview`,
        responseType: 'arraybuffer'
    }
};

export function RentalHistoryVerificationSettingsApi() {
    return createActions(actions);
}
